import { fireEvent, render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import { CanvasRenderer } from "./CanvasRenderer";

function form(variant: string, props = {}, onChange = jest.fn()) {
  render(
    <CanvasRenderer
      mode="runtime"
      config={{ columns: 12, rowHeight: 60, gap: 8, minRows: 3 }}
      elements={[
        {
          id: "field",
          type: "field",
          variant,
          props: { label: "Details", helperText: "Visible help", ...props },
          data_binding: { data_source_id: "main", field_path: "details" },
          gridColumn: 1,
          gridRow: 1,
          columnSpan: 6,
          rowSpan: 2,
        },
      ]}
      fieldState={{ details: { value: "First line\nSecond line", onChange } }}
    />,
  );
  return onChange;
}

it.each(["text", "textarea", "date"])(
  "uses consistent compact spacing for %s labels and help",
  (variant) => {
    form(variant);
    expect(screen.getByText("Details")).toHaveStyle({
      marginBottom: "4px",
      lineHeight: "1.4",
    });
    expect(screen.getByText("Visible help")).toHaveStyle({ marginTop: "4px" });
  },
);

it("retains textarea editing and multiline read-only content", () => {
  const onChange = form("textarea");
  fireEvent.change(screen.getByRole("textbox"), {
    target: { value: "Updated" },
  });
  expect(onChange).toHaveBeenCalledWith("Updated");
});

it("preserves line breaks and wraps a read-only value within its authored width", () => {
  form("textarea", { displayMode: "text" });
  expect(screen.getByText("First line Second line")).toHaveStyle({
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
  });
  expect(screen.queryByRole("textbox")).not.toBeInTheDocument();
});
